<template>
  <modal
    width="40"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="delete-illustration-wrapper ">
      <div class=" flex justify-center pb-4">
        <img class="img_wraps" src="../icons/no-shipping-service.svg"/>
      </div>
      <p class=" text-sm text-center">We couldn't find an available 3PL for this route at the moment. Please try a different route or try again later.</p>
    </div>
  </modal>
</template>

<script>
// import Modal from "@/components/partials/Modal/index";
export default {
  components: {
    // Modal,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },

  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped>
 .img_wraps{
  @apply w-[150px]
 }
</style>
